/** #@condition: quantum **/
/** Only for quantum **/

export default {
    GenericMarketContent: {
        // prettier-ignore
        layoutDescriptors: {
            types: {
                '37': {
                    selectionsHeaderContent: 'participant',
                    _mobile_selectionsHeaderContent: 'type', // DBX-6584 - shorten header for "Correct Score" market type
                },
                '82': {
                    selectionsHeaderContent: 'participant',
                },
                '153': {
                    selectionsHeaderContent: 'participant',
                },
                '192': {
                    selectionsHeaderContent: 'participant',
                    _mobile_selectionsHeaderContent: 'type', // DBX-6584 - shorten header for "Correct Score" market type
                },
                '284': {
                    selectionsHeaderContent: 'participant',
                },
                '1030': {
                    selectionsHeaderContent: 'participant',
                },
            },
        },
    },
    AggregatedMarketPane: {
        marketSignpostingIcons: {
            showMatchAccaIcon: false, // Should be off for Quantum according to MOJ-11044
        },
    },
    EventMarkets: {
        showMatchAccaBuilder: true, // By default, it is `false` so on Quantum it should be enabled explicitly
    },
    SelectionButtonView: {
        setGameMarketTypes: ['211', '262', '1828', '1090'],
    },
};
